<template>
  <div class="row" v-if="canShow">
    <div class="col" id="application-paidout-date">
      <div class="small text-muted-more">{{$t('LoanApplicationTimeline.loanPaidOut')}}</div>
      <div class="text-muted">{{$d(application.paidOutDate)}}</div>
    </div>
    <div class="col" id="application-paidout-amount">
      <div class="small text-muted-more">{{$t('LoanApplicationTimeline.payoutAmount')}}</div>
      <div class="text-amount text-muted">{{$n(application.loanAmount, 'currencyNoDecimals')}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'PaidOutApplicationStageComponent',
    props: ['application'],
    computed: {
      canShow() {
        return this.application.paidOutDate && this.application.loanAmount
      }
    }
  }
</script>
